import React, { useState } from 'react'
import { Panel, Row, Col, Icon } from 'rsuite'
import { downloadFileByPath, getDownloadAttachmentGrantee } from '../../redux/actions/contract'
import { doneLoading, startLoading } from '../../utils/loading'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import CenterChangeFormAttach from './CenterChangeFormAttach'

export default function CenterChangeFormView({
  schema: _schema,
  attachFiles,
  attachForm,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)

  const { isEContract } = props
  const optionSelected = schema?.saveContractChange?.value || 1

  const projectId = sessionStorage.getItem('projectId')

  const onDownload = async (fileObj) => {
    startLoading()

    var file = await downloadFileByPath(fileObj.path)
    //var file = await getDownloadAttachmentGrantee(projectId, fileObj.id)
    downloadFile(file, fileObj.name)

    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()

    var file = await downloadFileByPath(fileObj.path)
    //var file = await getDownloadAttachmentGrantee(projectId, fileObj.id)

    previewFile(file, fileObj.name)
    doneLoading()
  }

  return (
    <>
      <Panel>
        <Row style={{ marginTop: -20 }}>
          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
            {schema.saveContractChange.options.map((item) => (
              <p>
                <Icon
                  icon={
                    schema.saveContractChange.value == item.value ? 'check-square-o' : 'square-o'
                  }
                  size="lg"
                  style={{ marginRight: 10 }}
                />
                {item.label}
              </p>
            ))}
          </Col>
          {/* {schema.signType && (
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
              <p>
                <strong>{schema.signType.label} : </strong>
                {schema.signType.valueLabel}
              </p>
            </Col>
          )} */}
        </Row>

        <Row style={{ marginTop: 20 }}>
          {optionSelected != 1 && (
            <>
              {optionSelected != 4 && (
                <>
                  {schema.reqFileContractChange && (
                    <>
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <p>
                          <strong>{schema.reqFileContractChange.label} :</strong>
                        </p>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24}>
                        <div style={{ marginTop: 10 }}>
                          {schema.reqFileContractChange.value?.length > 0 ? (
                            <>
                              {schema.reqFileContractChange.options.map((item) => (
                                <>
                                  {schema.reqFileContractChange.value?.includes(item.value) && (
                                    <Col xs={24} sm={24} md={24} lg={24} style={{ marginLeft: 10 }}>
                                      {' '}
                                      - {item.label}{' '}
                                    </Col>
                                  )}
                                </>
                              ))}
                            </>
                          ) : (
                            <>
                              <Col xs={24} sm={24} md={24} lg={24}>
                                {' - ไม่เลือก -'}
                              </Col>
                            </>
                          )}
                        </div>
                      </Col>

                      {attachFiles && (
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <CenterChangeFormAttach
                            isView
                            isFilter
                            attachFiles={attachFiles}
                            onDownload={onDownload}
                            onPreview={onPreview}
                          />
                        </Col>
                      )}

                      {attachForm && (
                        <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 20 }}>
                          <CenterChangeFormAttach
                            isView
                            attachFiles={attachForm.attachFiles}
                            onDownload={onDownload}
                            onPreview={onPreview}
                          />
                        </Col>
                      )}
                    </>
                  )}
                </>
              )}

              {schema.note && (
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                  <p>
                    <strong>{schema.note.label} :</strong>
                  </p>
                  <div
                    style={{ marginLeft: 20 }}
                    dangerouslySetInnerHTML={{
                      __html: schema.note.value,
                    }}
                  />
                </Col>
              )}

              {optionSelected == 2 && (
                <>
                  {schema.witness1 && (
                    <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                      <p>
                        <strong>{schema.witness1.label} : </strong>
                        {schema.witness1.valueLabel}
                      </p>
                    </Col>
                  )}

                  {schema.witness2 && (
                    <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                      <p>
                        <strong>{schema.witness2.label} : </strong>
                        {schema.witness2.value}
                      </p>
                    </Col>
                  )}
                </>
              )}
            </>
          )}
        </Row>
      </Panel>
    </>
  )
}
